import React from 'react';
import styled, { ThemeContext } from 'styled-components';
import {
  FormHeader, Desc,
} from '../common/styles';
import SignInForm from './sign-in-form';
import LinkedInButton from '../common/linkedin-button';
import GoogleButton from '../common/google-button';
import Separator from '../common/separator';

const Gradient = styled.div`
  background-image: ${props => props.theme.linearGradientDarkThemeRect};
  width: 100%;
  padding: 20px 15px;
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  ${props => (props.theme.isMobile ? `
    padding: 35px 15px 15px 15px;
    border-radius: 4px;
    border: 1px solid ${props.theme.secondaryColor30Transparent};
    justify-content: flex-start;
  ` : `
    justify-content: center;
    min-height: 680px;
    padding: 40px;
  `)}
  ${props => props.theme.isXLarge && `
    width: 33vw;
    padding-left: 25px;
  `}
`;

const SDesc = styled(Desc)`
  margin: 10px 0 20px 0;
`;

const Prompt = styled(Desc)`
  margin-top: 23px;
  max-width: 320px;
  font-size: 14px;
  line-height: 15px;
  font-weight: ${props => props.theme.fontWeightHeavy};
  & > a {
    color: ${props => props.theme.primaryColor};
  }
`;

const Terms = styled(Desc)`
  margin: 16px 0 23px;
  max-width: 320px;
  font-size: 13px;
  line-height: 16px;

  & > a {
    color: ${props => props.theme.secondaryColor};
  }
`;

const Text = styled(Prompt)`
  font-weight: ${props => props.theme.fontWeightRegular};
`;

const Link = styled(Prompt)`
  margin-top: ${props => (props.theme.isMobile ? 6 : 12)}px;
`;

const Pane = () => (
  <React.Fragment>
    <FormHeader>Sign in to your account</FormHeader>
    <SDesc>
      Sign in to your account to read unlimited wires across the Livewire website.
    </SDesc>
    { !!window.Livewire.features.LoginWithGoogle && <GoogleButton eventType="sign_in" /> }
    <LinkedInButton />
    <Separator text="or" />
    <SignInForm />
    <Terms>
      {'By clicking Sign In you agree to Livewire’s '}
      <a href="/company/terms_and_conditions">Terms and Conditions</a>
      {' and '}
      <a href="/company/privacy">Privacy Disclaimer</a>
    </Terms>
    <Text>
      {'Having trouble signing in to your account? '}
    </Text>
    <Link>
      <a href="/forgot_password">Forgot your password?</a>
    </Link>
    <Prompt>
      {'Don’t have a Livewire account? '}
      <a href="/sign_up">Register free today</a>
    </Prompt>
  </React.Fragment>
);

export default function SignInPane() {
  const { isMobile } = React.useContext(ThemeContext);

  return isMobile ? (
    <Gradient>
      <Container>
        <Pane />
      </Container>
    </Gradient>
  ) : (
    <Container>
      <Pane />
    </Container>
  );
}
